import Toast from "components/toast";
import { _goToBack, _goToRoot } from "routers/helper";

export const onAddFactorRes = (res: { data: any }) => {
  Toast.success({ message: res.data.message });
  _goToRoot();
};

export const onEditFactorRes = (res: { data: any }) => {
  Toast.success({ message: res.data.message });
  // _goToBack();
};

export const onDeleteFactorRes = (res: { data: any }) => {
  Toast.success({ message: res.data.message });
};

export const onChangeFactorStatusRes = (res: { data: any }) => {
  Toast.success({ message: res.data.message });
};
